import MondayManagement from '../admin/MondayManagement'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { FaCheckSquare } from 'react-icons/fa'

const FORM_THANK_YOU_MAP = {
    estimados_2026_new_app: '/forms/architecture/new-quote/thank-you',
    estimados_2026_new_scope: '/forms/architecture/new-scope/thank-you',
    construction_new_project: '/forms/construction/new-quote/thank-you',
    roofing_new_project: '/forms/roofing/new-quote/thank-you',
    impact_windows_new_project: '/forms/impact-windows/new-quote/thank-you',
}

const FormPageTemplate = ({ titleKey, subtitleKey, defaultFormType, returnPath = '/', title: titleProp, subtitle: subtitleProp, initialPreselect: preselectProp, thankYouPath: thankYouPathProp }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const preType = searchParams.get('type')
    const preDesc = searchParams.get('desc')
    const initialPreselect = preselectProp || ((preType || preDesc) ? { type: preType, desc: preDesc } : null)
    const thankYouPath = thankYouPathProp || FORM_THANK_YOU_MAP[defaultFormType] || null

    const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
    const utmData = UTM_KEYS.reduce((acc, key) => {
        const val = searchParams.get(key)
        if (val) acc[key] = val
        return acc
    }, {})
    const hasUtm = Object.keys(utmData).length > 0

    const handleReturn = () => {
        navigate(returnPath)
    }

    return (
        <div className="min-h-screen bg-background pt-24 pb-12">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-center mb-8"
                >
                    <h1 className="text-4xl font-bold text-primary mb-4">{titleProp || t(titleKey)}</h1>
                    <p className="text-muted-foreground">
                        {subtitleProp || t(subtitleKey || 'admin.monday.fill_details', 'Please fill in the details below to start your application.')}
                    </p>
                </motion.div>

                <div className="bg-card rounded-2xl shadow-xl overflow-hidden border border-border">
                    <MondayManagement
                        session={null}
                        isPublicMode={true}
                        onReturn={handleReturn}
                        defaultFormType={defaultFormType}
                        initialPreselect={initialPreselect}
                        thankYouPath={thankYouPath}
                        utmData={hasUtm ? utmData : null}
                    />
                </div>

                {initialPreselect && (
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3 }}
                        className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2"
                    >
                        {[
                            t('admin.monday.trust_free_estimate'),
                            t('admin.monday.trust_licensed'),
                            t('admin.monday.trust_miami_team'),
                            t('admin.monday.trust_hablamos'),
                        ].map((item) => (
                            <span key={item} className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground">
                                <FaCheckSquare className="text-emerald-500 flex-shrink-0" />
                                {item}
                            </span>
                        ))}
                    </motion.div>
                )}
            </div>
        </div>
    )
}

export default FormPageTemplate
